import tinycolor from "tinycolor2";
import Verte from "verte";
import "verte/dist/verte.css";

export default {
  components: { Verte },
  props: {
    value: {
      default: "#000000",
      type: String,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    mode: {
      default: "flex",
      type: String,
    },
    name: String,
    id: String,
    inputFunc: {
      type: Function,
      default: () => {},
    },
    enableAlpha: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      color: "#000000",
    };
  },
  created() {
    if (this.value) {
      this.color = this.value.includes("#") ? this.value : `#${this.value}`;
    }
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
    setColor(color) {
      this.color = color;
      this.updateValue(color);
    },
    onlyHexColors(e) {
      let inputVal = e.target.value;
      inputVal = inputVal.includes("#") ? inputVal : `#${inputVal}`;

      if (inputVal.length >= 6) {
        const val = tinycolor(inputVal);

        if (val.isValid()) {
          this.setColor(inputVal);
          this.inputFunc(this.color);
        }
      } else {
        e.target.value = inputVal.replace("#", "");
      }
    },
  },
  watch: {
    color() {
      this.inputFunc(this.color);
    },
    value() {
      if (this.value) {
        this.setColor(this.value.includes("#") ? this.value : `#${this.value}`);

        this.inputFunc(this.color);
      }
    },
  },
};
